<template>
  <v-progress-linear
    :active="loading"
    :indeterminate="loading"
    absolute
    top
    color="red darken-2"
  />
</template>

<script>
import { VueOfflineMixin } from 'vue-offline'
import { eventBus } from '@/main'
export default {
  name: 'AppProgressToolbar',
  mixins: [VueOfflineMixin],
  data () {
    return {
      loading: false
    }
  },
  created () {
    eventBus.$on('APP_PROGRESS_TOOLBAR_START', callback => {
      eventBus.$emit('APP_VALIDATION_ERROR_RESET')
      this.loading = true
    })
    eventBus.$on('APP_PROGRESS_TOOLBAR_END', () => {
      this.loading = false
    })
  }
}
</script>
